import "./hb-safe.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

export default (user) => html`
    <div
        id="hb-safe"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        Safes ℹ️
                    </h3>
                    <div>
                        <span
                            id="hb-safe-add2"
                            class="hidden mr-2 text-base cursor-pointer text-gray-900 dark:text-white">
                            + Add
                        </span>
                        <button
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-safe">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </div>
                </div>
                <!-- Modal body -->
                <p
                    id="hb-safe-message"
                    class="text-sm font-medium mt-2 px-5 text-orange-500 dark:text-orange-300"></p>
                <ul
                    id="hb-safe-heartkeys"
                    class="mx-3 my-4 max-h-[60vh] overflow-y-auto"></ul>
                <ul
                    id="hb-safe-heartkeys2"
                    class="hidden m-5 space-y-3 text-base text-gray-900 dark:text-white"></ul>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="hb-safe-add"
                        type="button"
                        class="text-white w-full bg-logo hover:bg-logo/25 focus:ring-4 focus:outline-none focus:ring-logo/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-logo-dark dark:hover:bg-logo-dark/50 dark:focus:ring-logo-dark/10">
                        Create Safe
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
